module.exports = __webpack_public_path__ + "media/images/preview/default-image-7c3df60d16eed21e9a8a5c923a70321b.png";